import React, { useContext, useEffect } from "react";
import { Box } from "@mui/material";
import MDTypography from "components/MDTypography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { AuthContext } from "context";
import Link from "@mui/material/Link";
import SidenavCollapse from "./SidenavCollapse";
import { NavLink } from "react-router-dom";
import Divider from "@mui/material/Divider"; // Import del contesto

function Submenu(props) {
	const authContext = useContext(AuthContext); // Accediamo al contesto delle autorizzazioni
	const [isHovered, setIsHovered] = React.useState(false);
	const [submenuOpen, setSubmenuOpen] = React.useState(false);

	// Funzione per verificare se ci sono le autorizzazioni per le route
	const hasAnyAuth = (routeAuths) => {
		if (!routeAuths || routeAuths.length === 0) return true; // Se non ci sono auth richieste, mostra il menu
		return routeAuths.some((auth) => authContext.hasAuth(auth)); // Controlla se l'utente ha almeno una delle auth
	};

	// Filtra le route basate sulle autorizzazioni
	const filteredRoutes = props?.routes.filter((route) => {
		if (route.type == props?.name) return hasAnyAuth(route.auths); // Mostra solo le route per cui l'utente ha autorizzazioni
	});

	// if (filteredRoutes.length === 0) return null;

	const renderRoutesType = (typeFilter) => {
		return filteredRoutes.map(
			({
				type,
				name,
				icon,
				title,
				noCollapse,
				key,
				href,
				route,
				showInSidebar,
			}) => {
				let returnValue;

				if (type === typeFilter && showInSidebar) {
					returnValue = href ? (
						<Link
							href={href}
							key={key}
							target="_blank"
							rel="noreferrer"
							sx={{ textDecoration: "none" }}
						>
							<SidenavCollapse
								name={name}
								icon={icon}
								active={
									key === props?.collapseName.split("/")[0]
								}
								noCollapse={noCollapse}
							/>
						</Link>
					) : (
						<NavLink key={key} to={route}>
							<SidenavCollapse
								name={name}
								icon={icon}
								active={
									key === props?.collapseName.split("/")[0]
								}
							/>
						</NavLink>
					);
				}
				return returnValue;
			}
		);
	};

	function handleMouseEnter() {
		setIsHovered(true);
	}

	function handleMouseLeave() {
		setIsHovered(false);
	}

	function handleSubmenuOpen() {
		setSubmenuOpen((prevState) => {
			const newState = !prevState;
			return newState;
		});
	}

	useEffect(() => {
		//console.log("submenuOpen: ", submenuOpen);
	}, [submenuOpen]);

	useEffect(() => {
		//console.log("isHovered: ", isHovered);
	}, [isHovered]);

	return (
		<>
			{filteredRoutes.length > 0 && (
				<>
					<Box>
						<Box
							display="flex"
							alignItems="center"
							justifyContent="center"
							style={{
								cursor: "pointer",
								transition: "all 0.3s ease-in-out",
							}}
							onMouseEnter={() => handleMouseEnter()}
							onMouseLeave={() => handleMouseLeave()}
							onClick={() => handleSubmenuOpen()}
						>
							<MDTypography
								color={"white"}
								variant="body2"
								fontWeight="medium"
								style={{
									fontSize: isHovered ? "1.1rem" : "1rem",
									transition: "all 0.2s ease-in",
								}}
							>
								{props?.name}
							</MDTypography>
							<KeyboardArrowDownIcon
								color={"white"}
								style={{ marginLeft: "5px" }}
								fontSize={"medium"}
							/>
						</Box>
						{submenuOpen && (
							<Box>{renderRoutesType(props?.name)}</Box>
						)}
					</Box>
					<Divider light={true}></Divider>
				</>
			)}
		</>
	);
}

export default Submenu;
